import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { Subscription } from 'rxjs';
import {ApiHelper} from "../../core/services/apiHelper";
import { UserDao } from '../../core/services/dao/userDao';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  model: any = {};
  userAuthenticatedSubscription: Subscription;
  hasAdvertiserId: boolean = false;
  advertiserId = '';

  constructor(
    private authenticationService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    public apiHelper: ApiHelper,
    private userDao: UserDao
  ) {
    if (this.route.snapshot.params.advertiserId) {
      this.hasAdvertiserId = true;
      this.advertiserId = this.route.snapshot.params.advertiserId;
    } else {
      this.authenticationService.refreshLogin()
    }
  }

  ngOnInit() {

  }

  login() {
    this.userAuthenticatedSubscription = this.authenticationService
      .login(this.model.email, this.model.password)
      .subscribe((userIsAuthenticated: boolean) => {
        const user = this.userDao.getCurrentUser();
        if (user.isAdmin) {
          this.router.navigate(['manage', 'admin']);
        }
      });
  }

  ngOnDestroy(): void {
    if (this.userAuthenticatedSubscription) {
      this.userAuthenticatedSubscription.unsubscribe();
    }
  }
}
